import React from 'react';

/**
 * Operis Logo Component — Premium brand mark
 *
 * Renders the new Operis logo image.
 * Uses CSS filters for dark mode text visibility.
 */
const OperisLogo = ({
  size = 'md',
  showTagline = false,
  collapsed = false,
  className = '',
  light,
}) => {
  const sizeMap = {
    sm: 'h-6',
    md: 'h-8',
    lg: 'h-16',
  };

  const containerHeightMap = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-20',
  };

  const s = sizeMap[size];
  const containerSize = containerHeightMap[size];
  
  // If 'light' is explicitly requested (true), force the white logo version.
  // If 'light' is explicitly disabled (false), force the dark blue logo version (don't apply any filters).
  // If 'light' is undefined, let Tailwind's 'dark:' classes handle it automatically.
  let filterClass = '';
  if (light === true) {
    filterClass = 'brightness-0 invert opacity-90';
  } else if (light === undefined) {
    filterClass = 'dark:brightness-0 dark:invert dark:opacity-90';
  }

  if (collapsed) {
    return (
      <div className={`flex items-center justify-center ${containerSize} ${className}`}>
        <img
          src="/Operislogo.png"
          alt="Operis Logo"
          className={`w-auto object-contain h-full transition-all duration-300 ${filterClass}`}
        />
      </div>
    );
  }

  return (
    <div className={`flex items-center justify-center ${containerSize} ${className}`}>
      <img
        src="/Operislogo.png"
        alt="Operis Logo"
        className={`w-auto object-contain h-full transition-all duration-300 ${filterClass}`}
      />
    </div>
  );
};

export default OperisLogo;
